import { Component, OnInit, OnDestroy } from "@angular/core";
import { JwtService } from "../../core/services";
import { SchedulingService } from "./scheduling.service";
import { DevicesService } from "../devices/devices.service";
import { Device } from "../devices/device.model";
import { SortablejsOptions } from "angular-sortablejs/dist";
import { Constants } from "../../shared/constants";
import { SessionStateService } from "../../core/services/session-state.service";
import { GeneralService } from "../../shared/services/general.service";
import { SchedulingType, SCHEDULE_TYPE } from "./scheduling.constants";
import {
  Schedule,
  EconomicTariffs,
  WeekDay,
  WEEKDAY,
  Scheduling,
  Cycle,
  EconomicPeriod,
} from "./scheduling.model";
import { HousesService } from "../houses/houses.service";
import {
  HOUSE_TARIFF,
  HOUSE_CYCLE,
  HOUSE_COUNTRIES,
} from "../houses/houses.constants";
import { SharedUtils } from "../../shared/shared.utils";
import { Observable } from "rxjs/Observable";
import { DeviceType, GROUP } from "../devices/devices.constant";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-scheduling",
  templateUrl: "./scheduling.component.html",
  styleUrls: ["./scheduling.component.scss"],
})
export class SchedulingComponent implements OnInit, OnDestroy {
  boxOn: boolean;
  loading: boolean;
  menu: String[];
  hasType = false;

  constructor(
    private schedulingService: SchedulingService,
    private sessionStateService: SessionStateService,
    private devicesService: DevicesService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.generalService
      .getBoxConnectionStatus()
      .map((state) => {
        this.boxOn = state;
        this.initComponent();
      })
      .flatMap(() => {
        if (!this.schedulingService.economicTariffs) {
          return this.schedulingService.getEconomicTariffs();
        } else {
          return Observable.empty();
        }
      })
      .finally(() => (this.loading = false))
      .subscribe();
    this.generalService.connChange.subscribe((state) => {
      this.boxOn = state;
      if (state) {
        this.initComponent();
      }
    });
  }

  initComponent() {
    const excludedtabs = [];
    if (
      (this.sessionStateService.getHouseTariff() &&
        this.sessionStateService.getHouseTariff().tariff ===
          HOUSE_TARIFF.SIMPLE) ||
      this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN
    ) {
      excludedtabs.push(SchedulingType.ECONOMIC);
    }
    // console.log(excludedtabs);
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .finally(
        () =>
          (this.menu = Object.values(SchedulingType)
            .filter((k) => excludedtabs.indexOf(k) === -1)
            .map((k) => k.toLowerCase().replace(new RegExp("_", "g"), " ")))
      )
      .subscribe(
        (smartMeter: any) => {},
        (err) => excludedtabs.push(SchedulingType.POWER_LIMIT_CONTROL)
      );
    this.devicesService
      .getHouseModulesByGroups(
        this.sessionStateService.getHouse().houseId,
        DeviceType.CLIMATIZATION,
        undefined,
        [GROUP.HVAC, GROUP.THERMOSTAT]
      )
      .catch((e: any) => of(false))
      .finally(
        () =>
          (this.menu = Object.values(SchedulingType)
            .filter((k) => excludedtabs.indexOf(k) === -1)
            .map((k) => k.toLowerCase().replace(new RegExp("_", "g"), " ")))
      )
      .subscribe(
        (hasSetPoint) => {
          if (!hasSetPoint) {
            excludedtabs.push(SchedulingType.SETPOINT);
          }
        },
        (err) => {
          excludedtabs.push(SchedulingType.SETPOINT);
        }
      );
  }

  changeTab(event) {
    this.hasType = event;
  }

  getBoxConnectionStatus() {
    return this.boxOn;
  }

  ngOnDestroy() {
    this.generalService.initConnChange();
  }

  //   getEconomicSchedule(schedule: Schedule, economicTariffs: EconomicTariffs) {
  // // TODO: delete this.
  //     let economicSchedules: Schedule[] = [];

  //     const schedule2 = new Schedule(SCHEDULE_TYPE.ECONOMIC, '1243',
  //       [new WeekDay(WEEKDAY.MONDAY, true), new WeekDay(WEEKDAY.SUNDAY, true), new WeekDay(WEEKDAY.SATURDAY, true)]);

  //     const tariff: HOUSE_TARIFF = this.sessionStateService.getHouseTariff().tariff;
  //     const cycle: HOUSE_CYCLE = this.sessionStateService.getHouseTariff().cycle;

  //     const cycleSchedule: Cycle = economicTariffs.getCycle(tariff, cycle);

  //     schedule2.getWeekDays().forEach(element => {
  //       const economicPeriod = cycleSchedule.getEconomicPeriod(cycle, element.getWeekDay());
  //       economicSchedules = [...economicSchedules, ...(Schedule.createScheduleFromPeriod(schedule2.getType(),
  //         '123', [element], economicPeriod))];
  //       console.log('create economic schedules2 ', economicSchedules);

  //     });
  //     return new Scheduling(economicSchedules);
  //   }

  showCoachMark(type) {
    return this.sessionStateService.getCoachMarkIndividualState().get(type);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling.component.ts